import FAPictureCardCustomers from './FAPictureCardCustomers'
export default FAPictureCardCustomers
